import { render, staticRenderFns } from "./ReviewAndReport.vue?vue&type=template&id=c6aafd74&scoped=true&"
import script from "./ReviewAndReport.vue?vue&type=script&lang=ts&"
export * from "./ReviewAndReport.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewAndReport.vue?vue&type=style&index=0&id=c6aafd74&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aafd74",
  null
  
)

export default component.exports